import { apiRoute, API_V1 } from '../helpers/api-route'
import { fetchWrapper } from '../helpers/fetch-wrapper'

export const staffReportService = {
  email,
  generatePdf,
  get,
  save,
  sendToLocal,
  sendToRemote,
  getAnalysis
}

const API_BASE = apiRoute() + API_V1 + '/staff/reports'

function get (identifier) {
  return fetchWrapper.get(`${API_BASE}/${identifier}`)
}

function save (report) {
  return fetchWrapper.post(`${API_BASE}/${report.submission}`, report)
}

function email (id, email) {
  return fetchWrapper.post(`${API_BASE}/email/${id}`, { address: email })
}

function generatePdf (id) {
  return fetchWrapper.post(`${API_BASE}/generate/${id}`, {})
}

function sendToLocal (id) {
  return fetchWrapper.post(`${API_BASE}/local/${id}`, {})
}

function sendToRemote (id) {
  return fetchWrapper.post(`${API_BASE}/remote/${id}`, {})
}

function getAnalysis (identifier, byReportId = false) {
  return fetchWrapper.get(`${API_BASE}/analyse/none/${identifier}${byReportId ? '?byReportId=Yes' : ''}`)
}
